import HttpService from './http.service';

const refreshProp65 = async (configModel, language) => {
  try {
    var result = await HttpService.getAll(
      `Product/prop65?configModel=${configModel}&language=${language}`
    );
    return result.data.Message;
  } catch (error) {
    console.log(error);
  }
};

const refreshSupportDocuments = async (productId, countryId, language) => {
  try {
    var response = await HttpService.getAll(
      `SupportDocuments/${productId}/${countryId}/${language}`
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const refreshProductDescription = async (storeId, productId, language) => {
  try {
    if (storeId == undefined) {
      storeId = '10151';
    }
    var response = await HttpService.getAll(
      `Product/${storeId}/${productId}/${language}`
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export { refreshProp65, refreshSupportDocuments, refreshProductDescription };
